import { buildChartTheme, lightTheme } from '@visx/xychart'

export function buildCustomChartTheme( extensions ) {
  const theme = buildChartTheme( {
    ...lightTheme,
    ...extensions
  } )

  const colors = []

  for ( let i = 1; i <= 7; i++ ) {
    colors.push( `var( --color-graphSeries${i}, ${theme.colors[i - 1]})` )
  }

  theme.colors = colors
  theme.backgroundColor = `var( --color-graphBackground, ${theme.backgroundColor || '#000000'} )`

  theme.axisStyles.x.bottom.axisLabel.fill = `var( --color-graphXAxisLabel, ${theme.axisStyles.x.bottom.axisLabel.fill || '#ffffff'} )`
  theme.axisStyles.x.top.axisLabel.fill = `var( --color-graphXAxisLabel, ${theme.axisStyles.x.top.axisLabel.fill || '#ffffff'} )`

  theme.axisStyles.y.right.axisLabel.fill = `var( --color-graphYAxisLabel, ${theme.axisStyles.y.right.axisLabel.fill || '#ffffff'} )`
  theme.axisStyles.y.left.axisLabel.fill = `var( --color-graphYAxisLabel, ${theme.axisStyles.y.left.axisLabel.fill || '#ffffff'} )`

  theme.axisStyles.x.bottom.tickLabel.fill = `var( --color-graphXTickLabel, ${theme.axisStyles.x.bottom.tickLabel.fill || '#ffffff'} )`
  theme.axisStyles.x.top.tickLabel.fill = `var( --color-graphXTickLabel, ${theme.axisStyles.x.top.tickLabel.fill || '#ffffff'} )`

  theme.axisStyles.y.right.tickLabel.fill = `var( --color-graphYTickLabel, ${theme.axisStyles.y.right.tickLabel.fill || '#ffffff'} )`
  theme.axisStyles.y.left.tickLabel.fill = `var( --color-graphYTickLabel, ${theme.axisStyles.y.left.tickLabel.fill || '#ffffff'} )`
  
  theme.axisStyles.x.bottom.axisLine.stroke = `var( --color-graphXAxisLine, ${theme.axisStyles.x.bottom.axisLine.stroke || '#ffffff'} )`
  theme.axisStyles.x.top.axisLine.stroke = `var( --color-graphXAxisLine, ${theme.axisStyles.x.top.axisLine.stroke || '#ffffff'} )`

  theme.axisStyles.y.right.axisLine.stroke = `var( --color-graphYAxisLine, ${theme.axisStyles.y.right.axisLine.stroke || '#ffffff'} )`
  theme.axisStyles.y.left.axisLine.stroke = `var( --color-graphYAxisLine, ${theme.axisStyles.y.left.axisLine.stroke || '#ffffff'} )`

  theme.threshold = {
    stroke : 'var( --color-graphThreshold, --color-danger700 )'
  }

  return theme
}

export const occupancyTheme = buildCustomChartTheme( {
  ...lightTheme,
  backgroundColor : '#ffffff',
} )
